<template>
  <router-link to="/home" class="text-sm md:text-base block fixed bottom-0 left-0 right-0 text-center bg-white border-black border-t z-40">
    <ul ref="slider" class="h-9 leading-tight">
      <li class="py-2 px-8 border-black border-l block">
        Cosmopolis - a platform for research-based and collaborative art practices.
      </li>
      <li class="py-2 px-8 border-black border-l block">
        Cosmopolis #2: rethinking the human. 23 October – 23 December 2019. Centre Pompidou
      </li>
      <li class="py-2 px-8 border-black border-l block">
        Cosmopolis est une plateforme qui met l’accent sur pratiques artistiques enracinées dans la recherche
      </li>
      <li class="py-2 px-8 border-black border-l block">
        Cosmopolis #2: rethinking the human. 23 octobre - 23 décembre 2019. Centre Pompidou
      </li>
      <li class="py-2 px-8 border-black border-l block">
        Cosmopolis is a platform for research-based and collaborative art practices.
      </li>
      <li class="py-2 px-8 border-black border-l block">
        Cosmopolis #2: rethinking the human. 23 October – 23 December 2019. Centre Pompidou
      </li>
      <li class="py-2 px-8 border-black border-l block">
        Cosmopolis est une plateforme qui met l’accent sur pratiques artistiques enracinées dans la recherche
      </li>
      <li class="py-2 px-8 border-black border-l block">
        Cosmopolis #2: rethinking the human. 23 octobre - 23 décembre 2019. Centre Pompidou
      </li>
    </ul>
  </router-link>
</template>

<script>
import Flickity from 'flickity'
export default {

  name: 'Footer',

  data () {
    return {
      isDragging: false,
      flkty: null,
      tickerSpeed: -0.4,
      isPaused: false,
      loaded: false,
    }
  },

  methods: {
    start () {
      const el = this.$refs.slider

      this.flkty = new Flickity(el, {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        wrapAround: true,
        selectedAttraction: 0.015,
        friction: 0.25,
        percentPosition: true,
        setGallerySize: true,
        freeScroll: true,
        cellAlign: 'left'
      })

      this.flkty.on('dragStart', () => {
        this.isDragging = true
        this.isPaused = true
      })
      this.flkty.on('dragEnd', () => {
        setTimeout(() => {
          this.isDragging = false
        }, 10)
      })
      this.flkty.x = 0

      // el.addEventListener('mouseenter', this.pause, false)
      // el.addEventListener('focusin', this.pause, false)
      el.addEventListener('mouseleave', this.play, false)
      el.addEventListener('focusout', this.play, false)

      this.update()
    },
    update () {
      if (this.isPaused) return
      if (this.flkty.slides) {
        this.flkty.x = (this.flkty.x + this.tickerSpeed) % this.flkty.slideableWidth
        this.flkty.selectedIndex = this.flkty.dragEndRestingSelect()
        this.flkty.updateSelectedSlide()
        this.flkty.settle(this.flkty.x)
      }
      window.requestAnimationFrame(this.update)
    },
    pause () {
      this.isPaused = true
    },
    play () {
      if (this.isPaused) {
        this.isPaused = false
        window.requestAnimationFrame(this.update)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.start()
      setTimeout(() => {
        this.loaded = true
      }, 100)
      setTimeout(() => {
        this.clickable = true
        this.flkty.resize()
        this.$refs.slider.classList.add('show')
      }, 250)
    })
  }
}
</script>

<style lang="stylus" scoped>
  a
    color: black !important
  
  ul
    opacity: 0
    transition: opacity 0.5s ease-out
    
    &.show
      opacity: 1
  
  li
    white-space: nowrap
    width: auto
</style>
